<template>
    <div class="padding">
        <!-- <Loader v-show="loading"></Loader> -->
        <v-card class="margin">
            <v-container fluid>
                <ReportsPickers @change="setDates"></ReportsPickers>
                <v-layout row wrap>
                    <v-flex xs6 sm6>
                        <ClientSelector @selected="selectClient"> </ClientSelector>
                    </v-flex>
                    <v-flex xs6 sm6>
                        <ProjectSelector @selected="selectProject" :clientId="client_id"> </ProjectSelector>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="hideIcons()" right flat>Hide Icons</v-btn>
                <v-btn @click="requestData()" right flat>Explore</v-btn>
            </v-card-actions>
        </v-card>
        <v-card class="margin" v-if="!loading && (report.firstPart &&report.secondPart)">
            <v-card-title>
                Report
                <v-spacer></v-spacer>
            </v-card-title>
            <div class="clt">
                <DragableTree :sortByHours="byHours" :sortByName="byName" ref="tree" :model="report.firstPart"> </DragableTree>
            </div>
            <div class="underline"></div>
            <div class="clt">
                <DragableTree :sortByHours="byHours" :sortByName="byName" :model="report.secondPart"> </DragableTree>
            </div>
        </v-card>
        <Loader v-show="loading "></Loader>
    </div>
</template>


<script>
    import {
        Api
    } from '../../../services';
    import queryString from 'query-string';
    import Loader from '../Components/Loader.vue';
    import DragableTree from '../Components/DragableTree.vue';
    import ProjectSelector from './ProjectSelector.vue';
    import ClientSelector from './ClientSelector.vue';
    import ReportsPickers from './ReportsPickers.vue';
    import _ from 'lodash';
    export default {
        name: 'Reports',
        data() {
            return {
                items: [],
                data: [],
                loading: false,
                report: {
                    firstPart: false,
                    secondPart: false
                },
                project_id: false,
                client_id: false,
                params: {},
                byHours:true,
                byName:false
            }
        },
        components: {
            Loader,
            ProjectSelector,
            ClientSelector,
            ReportsPickers,
            DragableTree
        },
        created() {},
        methods: {
            auth() {},
            requestData() {
                this.report = {
                    firstPart: false,
                    secondPart: false
                };
                this.loading = true;

                console.log("PARAMS: ", this.params);

                Api
                    .Reports()
                    .get(this.params)
                    .then(res => {

                        console.log(res);

                        res.data.firstPart.level = 0;
                        res.data.secondPart.level = 0;
                        this.report = res.data

                    })
                    .then(() => this.loading = false)
            },
            selectProject(project_id) {

                console.log("selectProject", project_id);

                this.params.project_id = project_id;
                if (!project_id) {
                    delete this.params.project_id;
                }
            },
            selectClient(client_id) {

                console.log("selectClient", client_id);

                this.params.client_id = client_id;
                this.params.project_id = null;
                this.client_id = client_id;
                if (!client_id) {
                    delete this.params.client_id;
                }
            },
            setDates(params) {
                console.log('params', params)
                this.params = Object.assign({}, this.params, params);
            },
            hideIcons() {
                console.log('this.$refs', this.$refs)
                this.$refs.tree.hideIcons();
            }
        }
    }
</script>

<style>
    .underline {
        border-bottom: 2px solid #7a7a7a;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .margin {
        margin: 2px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Reports/Reports.vue